var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.233 21.49H5.726c-.964 0-1.89-.383-2.571-1.064a3.63 3.63 0 0 1-1.065-2.568V4.308c0-1.107 1.097-1.81 2.062-1.475q.208.07.402.21l.182.129a2.61 2.61 0 0 0 3.026-.005 3.66 3.66 0 0 1 4.24 0 2.61 2.61 0 0 0 3.026.005l.182-.13c1.031-.737 2.464 0 2.464 1.266v7.842h3.637a.78.78 0 0 1 .779.779v5.707a2.85 2.85 0 0 1-2.857 2.854m-1.299-7.783v4.93a1.296 1.296 0 0 0 1.299 1.296 1.3 1.3 0 0 0 1.298-1.297v-4.929zm-4.416-4.41a.78.78 0 0 0-.779-.779H6.505a.78.78 0 0 0-.55 1.329.78.78 0 0 0 .55.228h6.234a.78.78 0 0 0 .78-.778M12.48 12.41a.777.777 0 0 0-.779-.778H6.505a.78.78 0 0 0-.55 1.328.78.78 0 0 0 .55.228H11.7a.78.78 0 0 0 .78-.778m.26 2.335a.78.78 0 1 1 0 1.556H6.505a.78.78 0 0 1-.55-1.328.78.78 0 0 1 .55-.228z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt2Fill);
export default __webpack_public_path__ + "static/media/receipt2_fill.7fa54cdb99ef0b87489bc0fb20966880.svg";
export { ForwardRef as ReactComponent };